import { inject, injectable, interfaces } from 'inversify';
import { ACDLError } from '../../../__legacy__/models/error.model';
import { IPagedResult } from '../../../__legacy__/services/api.service';
import { IApiService } from '../../../__legacy__/services/api.service.base';
import { IApiServiceTraining } from '../../../__legacy__/services/api.service.training';
import { IInferenceListItemDto, IJobsRequestDto, ITrainingListItemDto } from '../../jobs/jobs.api.model';
import { IValidJobType, JOB_TYPE } from '../../jobs/jobs.model';
import { getJobApiPrefix } from './utils';

export interface IJobsApiService {
  getJobsAsync<T extends IValidJobType>(
    workspaceId: string,
    request: IJobsRequestDto,
    jobType: T
  ): Promise<IPagedResult<T extends JOB_TYPE.TRAINING ? ITrainingListItemDto : IInferenceListItemDto> | ACDLError>;
}

export namespace IJobsApiService {
  export const $: interfaces.ServiceIdentifier<IJobsApiService> = Symbol('JOBS_API_SERVICE');
}

@injectable()
export class JobsApiService implements IJobsApiService {
  constructor(@inject(IApiServiceTraining.$) private readonly apiTrainingService: IApiService) {}

  async getJobsAsync<T extends IValidJobType>(
    workspaceId: string,
    request: IJobsRequestDto,
    jobType: T
  ): Promise<IPagedResult<T extends JOB_TYPE.TRAINING ? ITrainingListItemDto : IInferenceListItemDto> | ACDLError> {
    return await this.apiTrainingService.getAsync<IPagedResult<T extends JOB_TYPE.TRAINING ? ITrainingListItemDto : IInferenceListItemDto>>(
      `/workspaces/${workspaceId}/${getJobApiPrefix(jobType)}`,
      { params: request }
    );
  }
}
